/* Vizuál karty per katalogový slug (katalog žije v Postgres, texty v locales).

   - photo: coloring-book kresba (magenta line art) v
     public/assets/checklist/<slug>.png. Dokud soubor chybí, karta ukáže
     placeholder rámeček (🖼️) s tooltipem `word` — viz onError v ShopPage.
   - word: krátký štítek destinace (tooltip placeholderu).
   - emoji: miniatura v drawer „Tvůj dárek". */

export interface ShopVisual {
  photo?: string;
  emoji?: string;
  word?: string;
}

const img = (slug: string) => `/assets/checklist/${slug}.webp`;

const entry = (slug: string, emoji: string, word: string): ShopVisual => ({
  photo: img(slug),
  emoji,
  word,
});

export const SHOP_VISUALS: Record<string, ShopVisual> = {
  'golden-gate':      entry('golden-gate', '🌉', 'Golden Gate'),
  'cable-car':        entry('cable-car', '🚋', 'Cable Car'),
  'painted-ladies':   entry('painted-ladies', '🏘️', 'Painted Ladies'),
  'chinatown':        entry('chinatown', '🏮', 'Chinatown'),
  'ferry-building':   entry('ferry-building', '☕', 'Ferry Building'),
  'alcatraz':         entry('alcatraz', '🗝️', 'Alcatraz'),
  'napa-valley':      entry('napa-valley', '🍷', 'Napa Valley'),
  'napa-balloon':     entry('napa-balloon', '🎈', 'Napa Balloon'),
  'highway-1':        entry('highway-1', '🚗', 'Highway 1'),
  'bixby-bridge':     entry('bixby-bridge', '🌁', 'Bixby Bridge'),
  'santa-barbara':    entry('santa-barbara', '🍦', 'Santa Barbara'),
  'hollywood-star':   entry('hollywood-star', '⭐', 'Walk of Fame'),
  'hollywood-sign':   entry('hollywood-sign', '🎥', 'Hollywood Sign'),
  'griffith-observatory': entry('griffith-observatory', '🔭', 'Griffith'),
  'malibu':           entry('malibu', '🏄', 'Malibu'),
  'in-n-out':         entry('in-n-out', '🍔', 'In-N-Out'),
  'route66-shake':    entry('route66-shake', '🥤', 'Route 66'),
  'universal-tour':   entry('universal-tour', '🎬', 'Universal'),
  'disneyland':       entry('disneyland', '🏰', 'Disneyland'),
  'fireworks-castle': entry('fireworks-castle', '🎆', 'Fireworks'),
  'coronado-beach':   entry('coronado-beach', '🏖️', 'Coronado'),
  'giant-sequoias':   entry('giant-sequoias', '🌲', 'Sequoias'),
  'joshua-tree':      entry('joshua-tree', '🌵', 'Joshua Tree'),
  'death-valley':     entry('death-valley', '🏜️', 'Death Valley'),
  'vegas-strip':      entry('vegas-strip', '🎰', 'Vegas Strip'),
  'roulette-spin':    entry('roulette-spin', '🎲', 'Roulette'),
  'vegas-hotel':      entry('vegas-hotel', '🏨', 'Vegas Hotel'),
  'vegas-chapel':     entry('vegas-chapel', '💒', 'Vegas Chapel'),
  'south-rim-sunset': entry('south-rim-sunset', '🌄', 'South Rim'),
  'heli-canyon':      entry('heli-canyon', '🚁', 'Grand Canyon'),
};

export const FALLBACK_VISUAL: ShopVisual = { emoji: '🎁', word: 'Surprise' };

export function visualFor(slug: string): ShopVisual {
  return SHOP_VISUALS[slug] ?? FALLBACK_VISUAL;
}
